<template>
    <div class="content">
       
    <div class="header">
        <div class="header-left">
          <img class="logo" src="../assets/pic_logo.png" alt="">
          <div class="text">易货领域可信记账工具</div>
        </div>
        <div class="header-center">
            <div>盘活工具</div>
            <div>引流工具</div>
            <div>营销工具</div>
        </div>
        <div class="header-tel">
          <div class="ico"><i></i><span>全国热线</span></div>
          <a href="tel:13632764231" class="phone">136 3276 4231</a>
       </div>
    </div>
    <nav class="nav">
      <router-link :class="{'active':$route.path=='/'}" to="/">首页</router-link>
      <router-link :class="{'cur':$route.path== item.url}" v-for="item in categoryList" :key="item.url"  :to="{path:item.url,query:{id:item.id,pic:item.extra}}">{{item.name}}</router-link>
      <!-- <router-link to="/videoList">站点视频</router-link> -->
    </nav>
    </div>
</template>
<script>
export default {
  props: {
    categoryList: {
      type: Array,
      required: true
    }
  },
    data() {
      return {
        imgState: false,
        data:''
      }
    }
}
</script>
<style scoped lang='less'>
.content{
   .show{
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.5);
      position: fixed;
      top: 0px;
      left: 0px;
      right: 0px;
      bottom: 0px;
      margin: auto;
      z-index: 9999;
      text-align: center;
      img{
        margin:3rem auto;
        margin-bottom: 0;
        width: 3.1rem;
      height: 3.1rem;
      
      }
      .desc{
        font-size: .24rem;
        color: #F1F1F1;
      }
      
    }
    .unshow{
      display:none;
    }
   .header{
      height: 1rem;
      background-color:#EC6A3D ;
      display: flex;
      justify-content: space-between;
      padding: 0.04rem .3rem;
      .header-left{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .logo{
            width: 1.31rem;
            height: .46rem;
            margin-bottom: 0.03rem;
        }
        .line{
          height: 1px;
          width: 2rem;
          background-color: #fff;
          margin: .05rem 0;
          transform: scaleY(0.5);
        }
        .text{
          font-size: 0.2rem;
          font-family: PingFang SC-Bold, PingFang SC;
          color: #FFFFFF;
          line-height: 0.23rem;
          &::before {
          content: '';
          display: block;
          height: 1px;
          transform: scaleY(0.5);
          background: #fff;
          margin: 0.03rem 0;
        }
        }
      }
      .header-center{
        display: flex;
        flex-direction: column;
        position: relative;
        &::after {
          content: '';
          display: block;
          height: 1.2rem;
          width: 1px;
          transform: scaleY(0.5);
          background: #fff;
          margin: 0.03rem 0;
          position: absolute;
          top:-.16rem;
          left:-.3rem
        }
        div{
          font-size: 0.2rem;
          font-family: PingFang SC-Bold, PingFang SC;
          color: #FFFFFF;
          line-height: 0.3rem;
        }

      }
      .header-tel{
           height: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 0.2rem;
            .ico{
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 0.05rem;
              i{
                width: 0.3rem;
                height: 0.3rem;
                background-image: url('../assets/home_icon_tele.png');
                background-size:0.3rem 0.3rem;
                display: inline-block;
                margin-right: 0.1rem;

            }
              span{
                font-size: .26rem;
                color: #fff;
                font-weight: bold;
            }
            } 
            a{
                 font-size: .22rem;
                  color: #fff;
            }
            
      }
    }
    .nav{
        height: 0.64rem;
        background: #FCECDD;
        display: flex;
        justify-content:  space-between;
        padding:0 .24rem;
        overflow:scroll;
        overflow-y: hidden;
        a{
          color: #904B23;
          font-size: 0.24rem;
          line-height: 0.64rem;
          height: 0.64rem;
          width: auto;
          display: inline-block;
          padding: 0 .1rem;
          white-space:nowrap
          }
       .active{
            font-size: 0.28rem;
            font-weight: bold;
            color: #E96E2C;
            line-height: 0.64rem;
       }
    }
    .nav::-webkit-scrollbar {display:none}
}
    
</style>



// WEBPACK FOOTER //
// src/components/header.vue